/**
 * HTTP fallback push for queue/session state (QueueSession DO).
 * WebSocket sync is primary; this ensures persistence when WS path skips empty idle.
 */
import { CLOUD_API_URL } from '../config/serverConfig';

function getAuthToken(): string | null {
  try {
    const raw = localStorage.getItem('maestro_auth');
    if (!raw) return null;
    const { accessToken } = JSON.parse(raw);
    return accessToken || null;
  } catch {
    return null;
  }
}

export async function pushQueueSnapshotToServer(payload: Record<string, unknown>): Promise<void> {
  const token = getAuthToken();
  if (!token) return;
  try {
    await fetch(`${CLOUD_API_URL}/api/queue/sync`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'omit',
      body: JSON.stringify(payload),
      signal: AbortSignal.timeout(5000),
    });
  } catch {
    // Best-effort — sync must not block playback UI
  }
}
